<template>
  <div class="my-5">
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="8" offset-md="2">
          <v-card rounded>
            <v-card-title>
              {{ posted ? "" : "Proforma" }} Invoice
              <v-spacer />
              <!-- <v-btn @click="download" outlined dark color="orange darken-3">
                <v-icon left>mdi-cloud-download</v-icon>
                Download
              </v-btn> -->

              <v-dialog persistent v-model="dialog" width="500">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-on="on"
                    v-bind="attrs"
                    dark
                    color="green darken-3"
                    class="ml-2"
                  >
                    <v-icon left>mdi-cash-multiple</v-icon>
                    Pay Now
                  </v-btn>
                </template>
                <v-card class="mx-auto">
                  <v-card-title>
                    Already Paid for this Event?
                    <v-spacer />
                    <v-btn icon @click="dialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="paymentForm" v-model="isValid">
                      <v-text-field
                        dense
                        outlined
                        v-model="transactionCode"
                        placeholder="Enter Mpesa Transaction Number"
                        label="Enter Mpesa Transaction Number"
                        :rules="paymentRules"
                      >
                        <template v-slot:append>
                          <v-icon>mdi-credit-card</v-icon>
                        </template>
                      </v-text-field>
                    </v-form>
                  </v-card-text>
                  <div
                    v-if="$vuetify.breakpoint.mobile"
                    class="d-flex flex-column"
                  >
                    <v-btn
                      color="green darken-3"
                      class="align-self-center white--text mb-3"
                      min-width="90%"
                      @click="confirmPayment"
                      :disabled="transactionCode.length < 1"
                    >
                      Confirm Payment
                    </v-btn>
                    <div class="align-self-center mb-3">or</div>
                    <v-btn
                      color="primary"
                      @click="pay"
                      min-width="90%"
                      class="mb-3 align-self-center white--text"
                    >
                      Proceed To Payment
                    </v-btn>
                  </div>
                  <v-card-actions v-if="!$vuetify.breakpoint.mobile">
                    <v-btn
                      color="green darken-3"
                      @click="pay"
                      class="white--text"
                    >
                      Proceed To Payment
                    </v-btn>
                    <v-spacer />
                    <v-btn
                      color="primary"
                      @click="confirmPayment"
                      :disabled="transactionCode.length < 1"
                    >
                      Confirm Payment
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-title>
            <v-divider />

            <v-card-text
              class="pa-0"
              style="position: relative; background: #525659"
              :style="{
                height: isMobile ? 'auto' : '80vh',
                minHeight: isMobile ? '300px' : '700px',
                background: isMobile ? '#ffffff' : '#525659',
              }"
            >
              <!-- Loader while Blob URL is being created/loaded -->
              <div v-if="!pdfUrl" class="pa-4 white" style="height: 100%">
                <v-skeleton-loader type="image" height="100%" />
              </div>

              <template v-else>
                <!-- Mobile Optimized View -->
                <div
                  v-if="isMobile"
                  class="pa-12 text-center d-flex flex-column align-center justify-center"
                >
                  <v-icon size="100" color="primary lighten-4"
                    >mdi-file-pdf-box</v-icon
                  >
                  <div
                    class="mt-6 grey--text text--darken-2 headline font-weight-bold"
                  >
                    Invoice Preview
                  </div>
                  <div class="mt-2 grey--text subtitle-1 mb-8">
                    Your invoice is ready. Since you are on a mobile device,
                    please use the button below to view it.
                  </div>
                  <v-btn
                    x-large
                    color="primary"
                    class="text-none px-8 rounded-lg shadow-lg"
                    @click="openPdfInNewTab"
                  >
                    <v-icon left>mdi-eye</v-icon>
                    Open Invoice
                  </v-btn>
                  <div class="mt-4 grey--text caption">
                    The document will open in your device's native PDF viewer.
                  </div>
                </div>

                <!-- Desktop Iframe View -->
                <iframe
                  v-else
                  :src="pdfUrl"
                  width="100%"
                  height="100%"
                  frameborder="0"
                  style="border: none; display: block"
                  title="Invoice Viewer"
                  loading="lazy"
                ></iframe>
              </template>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <Checkout />
  </div>
</template>

<script>
import fileType from "file-type";
import { appUrl } from "../../../environment/environment";
import Checkout from "@kinetics254/paygate/src/views/Checkout.vue";

export default {
  name: "Invoice",
  components: { Checkout },
  data() {
    return {
      posted: undefined,
      transactionCode: "",
      dialog: false,
      isValid: false,
      pdfUrl: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.posted = v.$route.params.posted;
      v.$store.dispatch("Events/getProforma", v.$route.params.bookingNo);
      v.$store.dispatch("Events/getBooking", v.$route.params.bookingNo);
    });
  },
  watch: {
    proforma: {
      immediate: true,
      handler(val) {
        if (val) {
          this.createPdfUrl(val);
        }
      },
    },
  },
  computed: {
    proforma() {
      return this.$store.getters["Events/proforma"];
    },

    booking() {
      return this.$store.getters["Events/booking"];
    },

    paymentRules() {
      return [(v) => !!v || "Transaction is required"];
    },
    isMobile() {
      // Production-grade mobile detection
      return (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ) || window.innerWidth <= 768
      );
    },
  },
  methods: {
    createPdfUrl(base64) {
      // Clear existing URL if any
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl);
      }

      try {
        const binaryString = window.atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([bytes], { type: "application/pdf" });
        this.pdfUrl = URL.createObjectURL(blob);
      } catch (e) {
        console.error("Error creating PDF Blob URL:", e);
        this.pdfUrl = null;
      }
    },
    /**
     * Opens PDF in a new tab - most reliable for mobile devices
     */
    openPdfInNewTab() {
      if (!this.pdfUrl) return;
      window.open(this.pdfUrl, "_blank");
    },
    download: async function () {
      const myBuffer = Buffer.from(this.proforma, "base64");
      await fileType.fromBuffer(myBuffer).then((res) => {
        const path = `data:${res.mime})};base64,${this.proforma}`;
        const element = document.createElement("a");
        element.setAttribute("href", path);
        element.setAttribute(
          "download",
          `${this.$root.decryptRoute(this.$route).params.bookingNo}.pdf`
        );
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      });
    },

    pay: function () {
      let payload = {
        payerID: this.booking.referenceNo,
        sourceDocumentNo: this.booking.bookingNo,
        description: "Booking Fees",
        amount: this.booking.amountInclVAT,
        accountNo: this.booking.phoneNo || "",
        success_url: `${appUrl}${
          this.$router.resolve({
            name: "BookingView",
            ...this.$root.encryptRoute({
              params: { bookingNo: this.booking.bookingNo },
            }),
          }).href
        }`,
        fail_url: window.location.href,
      };

      payload = btoa(JSON.stringify(payload));
      // window.location.href = `${payGateUrl}?payload=${payload}`;
      this.$checkout.pay(payload);
    },
    confirmPayment: function () {
      if (!this.isValid) {
        this.$refs.paymentForm.validate();
      } else {
        this.dialog = false;
        this.$store.dispatch("Events/confirmPayment", {
          bookingNo: this.booking.bookingNo,
          transactionCode: this.transactionCode,
        });
      }
    },
  },
  beforeDestroy() {
    if (this.pdfUrl) {
      URL.revokeObjectURL(this.pdfUrl);
    }
  },
};
</script>

<style scoped>
.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}
</style>
